/* ============================================================
   CEDARWELL — global.js
   Lightweight, dependency-free interactions.
   ============================================================ */
(function () {
  "use strict";

  /* ---- Mobile nav ---- */
  function initNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-nav]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Product gallery ---- */
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return;
    var main = gallery.querySelector("[data-gallery-main] img");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        if (main && src) { main.src = src; main.srcset = ""; }
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---- AJAX add-to-cart (Shopify) ---- */
  function initAddToCart() {
    var forms = document.querySelectorAll("form[action$='/cart/add'], form[action*='/cart/add']");
    forms.forEach(function (form) {
      form.addEventListener("submit", function (e) {
        // Allow normal submit if fetch is unavailable
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector("[type='submit']");
        var original = btn ? btn.textContent : "";
        if (btn) { btn.textContent = "Adding…"; btn.disabled = true; }
        var data = new FormData(form);
        fetch("/cart/add.js", { method: "POST", body: data, headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function () { return fetch("/cart.js", { headers: { "Accept": "application/json" } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (btn) { btn.textContent = "Added ✓"; }
            setTimeout(function () { if (btn) { btn.textContent = original; btn.disabled = false; } }, 1600);
          })
          .catch(function () {
            if (btn) { btn.textContent = original; btn.disabled = false; }
            form.submit();
          });
      });
    });
  }

  function updateCartCount(count) {
    var el = document.querySelector("[data-cart-count]");
    if (!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? "inline-flex" : "none";
  }

  /* ---- Header depth on scroll ---- */
  function initHeaderScroll() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var update = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ---- Newsletter inline note ---- */
  function initYear() {
    var y = document.querySelector("[data-year]");
    if (y) y.textContent = new Date().getFullYear();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initNav();
    initHeaderScroll();
    initReveal();
    initGallery();
    initAddToCart();
    initYear();
  });
})();
